import { SimpleCertificate } from 'app/library/certificate/models/simple-certificate.model';
import { PaginatedSubentityStateModel } from 'app/projects/subentity/src/lib/models/paginated-subentity.state-model';

export class CourseOfferingParticipantsStateModel extends PaginatedSubentityStateModel {
    static identifier = 'CourseOfferingParticipantsStateModel';

    assignedCertificates: SimpleCertificate[];
    numberOfParticipants: number;

    constructor() {
        super(CourseOfferingParticipantsStateModel.identifier);
    }
}
